import { put, call, takeLatest } from "redux-saga/effects";

import { getAPIPayload } from "../../../apis/getApi";
import { postAPIPayload } from "../../../apis/postApi";
import { patchAPIPayload } from "../../../apis/postApi";
import { deleteAPIPayload } from "../../../apis/deleteApi";
import { scansAction } from "../../slices/scans/scansSlice";

export function* fetchScanSettingsSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(scansAction.fetchScanSettings(response));
}

export function* updateScanSettingsSaga({ payload }) {
  let response = yield call(patchAPIPayload, payload);
  if (!response?.success) {
    response = yield call(postAPIPayload, payload);
  }
  yield put(scansAction.fetchUpdateScanSettings(response));
}

export function* fetchScansSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(scansAction.fetchScansData(response));
}

export function* fetchScheduledScansSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(scansAction.fetchScheduledScansData(response));
}

export function* startScanSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(scansAction.fetchStartScan(response));
}

export function* updateScheduledScanSaga({ payload }) {
  const response = yield call(patchAPIPayload, payload);
  yield put(scansAction.fetchUpdateScheduledScan(response));
}

export function* deleteScheduledScanSaga({ payload }) {
  const response = yield call(deleteAPIPayload, payload);
  yield put(scansAction.fetchDeleteScheduledScan(response));
}

export function* fetchScanInsightsSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(scansAction.fetchScanInsights(response));
}

export function* acknowledgeScanInsightsSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(scansAction.fetchAcknowledgeScanInsights(response));
}

export function* watchScansSagaAsync() {
  yield takeLatest(scansAction.getScanSettings, fetchScanSettingsSaga);
  yield takeLatest(scansAction.updateScanSettings, updateScanSettingsSaga);
  yield takeLatest(scansAction.getScansData, fetchScansSaga);
  yield takeLatest(scansAction.getScheduledScansData, fetchScheduledScansSaga);
  yield takeLatest(scansAction.startScan, startScanSaga);
  yield takeLatest(scansAction.updateScheduledScan, updateScheduledScanSaga);
  yield takeLatest(scansAction.deleteScheduledScan, deleteScheduledScanSaga);
  yield takeLatest(scansAction.getScanInsights, fetchScanInsightsSaga);
  yield takeLatest(scansAction.acknowledgeScanInsights, acknowledgeScanInsightsSaga);
}
